import { useEffect } from 'react'
import type { SurvenueDTO } from '@whatremains/shared'

/**
 * Ce qui vient d'arriver.
 *
 * ## Pourquoi ce panneau existe
 *
 * Reproche d'Enzo, en jouant : « je viens de faire un choix dans une quête et
 * elle s'est juste mise dans "derrière toi" sans que je sache ce que mon choix
 * a fait. Si j'ai réussi ou pas. Rien expliqué. Je sais pas si j'ai gagné mon
 * xp et mon or. Je comprends rien. »
 *
 * L'information existait déjà entièrement dans la réponse du serveur : la note
 * narrative, l'or, l'expérience, les mouvements de renom. Elle était affichée
 * en gris, dans une liste qu'il fallait aller ouvrir. **Ce qui manquait n'était
 * pas la donnée, c'était le moment.**
 *
 * ## Ce qu'il ne fait pas
 *
 * Il ne commente pas, il n'explique aucune mécanique, et il ne dit jamais ce
 * qui serait arrivé autrement. Le canon interdit d'annoncer d'avance ce qu'un
 * choix coûte, sans quoi chaque décision devient un calcul. Il n'interdit pas
 * de constater après coup : le mystère porte sur ce qui VA arriver.
 *
 * Il se ferme au clic, à l'Échap, et il ne bloque rien derrière lui : un
 * panneau qu'on doit congédier pour continuer à jouer devient une corvée au
 * bout de trois.
 */
export function Survenue({ survenue, surFermer }: { survenue: SurvenueDTO | null; surFermer: () => void }) {
  useEffect(() => {
    if (!survenue) return
    const auClavier = (e: KeyboardEvent) => {
      if (e.key === 'Escape') surFermer()
    }
    window.addEventListener('keydown', auClavier)
    return () => window.removeEventListener('keydown', auClavier)
  }, [survenue, surFermer])

  if (!survenue) return null

  return (
    <div className="survenue-fond" onClick={surFermer} role="presentation">
      <div
        className={`survenue survenue-${survenue.ton}`}
        role="status"
        aria-live="polite"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="survenue-titre">{survenue.titre}</div>

        {survenue.texte && <p className="survenue-texte">{survenue.texte}</p>}

        {survenue.lignes.length > 0 && (
          <ul className="survenue-lignes">
            {survenue.lignes.map((l, i) => (
              <li key={i} className={l.sens}>
                <span>{l.quoi}</span>
                <b>{l.valeur}</b>
              </li>
            ))}
          </ul>
        )}

        <button className="action" onClick={surFermer}>
          Bien
        </button>
      </div>
    </div>
  )
}
